// Presentation only. Keep canonical time values in state, requests and session IDs.
export const getCompetitionDisplayTime = (event, venue, date, time) => {
    const configured = (event?.venues || []).find(item => item.id === venue)?.sessions?.[date] || [];
    const special = [...(event?.orchestraSessions || []), ...(event?.masterclassSessions || [])]
        .some(item => item.venue === venue && item.date === date && item.time === time);
    const revision = event?.competitionTimeDisplay?.times?.[`${venue}_${date}_${time}`];
    return configured.includes(time) && !special && typeof revision === 'string'
        && /^([01]\d|2[0-3]):[0-5]\d-([01]\d|2[0-3]):[0-5]\d$/.test(revision)
        && revision.slice(0, 5) < revision.slice(6) ? revision : time;
};
